<os-toolbar></os-toolbar>

<section class="layout-contents-section">
  <router-outlet></router-outlet>
</section>

<!--<footer class="footer">-->
<!--  <cn-footer></cn-footer>-->
<!--</footer>-->
